module.exports = __webpack_public_path__ + "media/battlePlanPP.37b4328f.mp3";